import { ProcessoRepository } from "../repository/processo_repository";

export class ProcessoService {
	constructor() {
		this.processoRepository = new ProcessoRepository();
	}

	async getAll(unidadeDistribuidoraId) {
		return await this.processoRepository.getAll(unidadeDistribuidoraId);
	}
}
